import { render, staticRenderFns } from "./diagnosticListing.vue?vue&type=template&id=1379481a&"
import script from "./diagnosticListing.vue?vue&type=script&lang=js&"
export * from "./diagnosticListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports